import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3acdc5b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Point" }
const _hoisted_2 = { class: "handle-btns" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = { class: "decultModal" }
const _hoisted_5 = { class: "point-other" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将文件拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 .xls, .xlsx 格式，不超过20m，一次最多修改100个客户", -1))

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePermission } from '@/hooks/usePermission'
import { ref, reactive, watch } from 'vue'
import PageModal from '@/components/PageModal.vue'
import LfTable from '@/components/LfTable.vue'
import XLSX from 'xlsx'

import { pointTableConfig } from './config/point.config'
import { getPageListData, getListData, createPageData } from "@/service/main/system";
import {
  PointReasonItem,
  useModalDecultPointReason
} from '@/hooks/usePageModal'
import { ElForm, ElMessage, ElMessageBox, ElUpload } from "element-plus";
import localCache from "@/utils/cache";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Point',
  setup(__props) {

const updatePoint = usePermission('userExpand', 'updatePoint')

const modalTitle = ref('积分操作')

const pageModalRef = ref<InstanceType<typeof PageModal>>()
const batchEditModalRef = ref<InstanceType<typeof PageModal>>()
const defaultInfo = ref({})

const otherInfo = reactive({
  type: 1
})

const url = ref('')
const batchEditurl = ref('')

const changePointItem = modalConfig.formItems.find(
  (item) => item.field === 'changePoint'
)
changePointItem!.rules.push({
  validator: (rule: any, value: any, callback: any) => {
    if (value <= 0) {
      callback(new Error('金币数量必须大于零'))
    }
    if (otherInfo.type == 0) {
      if (value > defaultInfo.value.point) {
        callback(new Error('扣除金币输入金币数量不能超过用户拥有的金币数量'))
      }
    }
    callback()
  },
  trigger: 'blur'
})

const handleEditClick = async (item: any, type: number) => {
  url.value = `/main/userExpand/${item.id}/changePoint`
  const reasonItem = modalConfig.formItems.find(
    (item) => item.field === 'reason'
  )

  try {
    const list = await getReasonList(type)
    const [fetchSuggestions] = useModalDecultPointReason(list)

    reasonItem!.otherOptions['fetch-suggestions'] = fetchSuggestions
  } catch (error) {
    const [fetchSuggestions] = useModalDecultPointReason()

    reasonItem!.otherOptions['fetch-suggestions'] = fetchSuggestions
  }

  if (type == 1) {
    modalTitle.value = '添加金币'
    reasonItem!.isHidden = true
  } else {
    modalTitle.value = '扣除金币'
    reasonItem!.isHidden = false
  }
  otherInfo.type = type
  defaultInfo.value = { ...item }
  pageModalRef.value!.dialogVisible = true
}

const getReasonList = async (flow: number) => {
  const data = await getListData('/main/pointReason/list', { flow })
  const list = new Array<PointReasonItem>()
  for (const item of data) {
    list.push({
      value: item.reason,
      title: item.reason,
      point: item.point
    })
  }

  return list
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const handleSelect = (item: any) => {
  defaultInfo.value['changePoint'] = item.point
  defaultInfo.value['reason'] = item.title
}

// 扣除记录
const dialogVisible = ref(false)
const dialogTitle = ref('')
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const tableTitle = ref('');
const batchAddDialogVisible = ref(false)

const pageInfo = ref({ pageNo: 1, pageSize: 10 })
let queryInfo = { userId: -1, flow: 0, pageNo: 1, pageSize: 10 }

const handleDecultPointClick = (item: any) => {
  dialogVisible.value = true
  dialogTitle.value = '扣除记录'
  tableTitle.value = '扣除列表'
  getPageData(item.id, 0)
}

const handleIncreasePointClick = (id: number) => {
  dialogVisible.value = true;
  dialogTitle.value = '增涨记录'
  tableTitle.value = '增涨列表'
  getPageData(id, 1);
}

const getPageData = async (id: number, flow: number) => {
  queryInfo = {
    userId: id,
    flow: flow,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }

  const data = await getPageListData(
    '/main/pointRecord/queryByCondition',
    queryInfo
  )
  dataList.value = data.list
  dataCount.value = Number(data.total)
}

const dialogClose = ()=> {
  debugger
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 10;
  dataCount.value = 0;
}

//监听分页事件
watch(pageInfo, () => getPageData(queryInfo.userId, queryInfo.flow))


const confirmLoading = ref(false)
const points = ref(100)
const formRef = ref<InstanceType<typeof ElForm>>()

const handleBatchEditPoint = () => {
  batchAddDialogVisible.value = true
}

const headers = ref({})
const fileList = ref<any[]>([])
const token = localCache.getCache('token')
headers.value = {
  'Authorization': `Bearer ${token}`
}

const handleChange = (file: any, excelFileList: any)=> {
  fileList.value = excelFileList
}

const handleSuccess = (res: any) => {
}

const uploadRef = ref<InstanceType<typeof ElUpload>>()

const handleCancleClick = () => {
  uploadRef.value.clearFiles()
  fileList.value = []
  confirmLoading.value = false
  batchAddDialogVisible.value = false
}
const handleConfirmClick = () => {
  confirmLoading.value = true
  if (typeof(points.value) == 'string' && points.value == '') {
    ElMessage.error({ type: 'error', message: '金币数是必传的' })
    confirmLoading.value = false
    return
  }
  if (fileList.value.length <= 0) {
    ElMessage.error({ type: 'error', message: '请先上传文件' })
    confirmLoading.value = false
    return
  }
  uploadRef.value!.submit()
}

const handleCloseDialog = ()=> {
  uploadRef.value.clearFiles()
  fileList.value = []
  confirmLoading.value = false
  batchAddDialogVisible.value = false
}
const store = useStore()

const uploadHttpRequest = ()=> {
  let fileReader = new FileReader()
  fileReader.readAsBinaryString(fileList.value[0].raw)
  let dataJson
  fileReader.onload = ev => {
    const workbook = XLSX.read(ev.target.result, {type: 'binary'})
    const wsname = workbook.SheetNames[0]
    dataJson = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {header: 1, defval: ''});
    const datas = dataJson.map( e => e[0])
      .filter(e =>e!='');
    if (datas.length > 100) {
      ElMessage.error({ type: 'error', message: '一次最多修改100个客户' })
      confirmLoading.value = false
      return;
    }
    if (datas.length < 1) {
      ElMessage.error({ type: 'error', message: '未检测到客户昵称' })
      confirmLoading.value = false
      return;
    }

    createPageData('/main/userExpand/batch/update', {
      excelDatas: datas,
      points: points.value
      }).then((res)=>{
      uploadRef.value.clearFiles()
      fileList.value = []
      confirmLoading.value = false
      batchAddDialogVisible.value = false

      store.dispatch('system/getPageListAction', {
        pageName: 'userExpand',
        queryInfo: store.state.system.queryInfo
      })
      if (res.flag == false) {
        ElMessageBox.confirm(
          '添加失败，请重试',
          {
            confirmButtonText: '确认',
            type: 'error',
            showCancelButton: false
          })
          return
      }

      debugger
      const message = '<font color="red">添加完成，以下昵称重名，请手动为其添加积分：</font><br/>'+res.duplicates.toString()
      + '<br/><font color="red">以下昵称不存在：</font><br/>'+res.unknowns.toString();
      ElMessageBox.alert(
        message,
        '注意:',
        {
          confirmButtonText: '确认',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      onBatchEditPointClick: handleBatchEditPoint,
      pageName: "userExpand"
    }, {
      opr: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(updatePoint))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleEditClick(scope.row, 1))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加金币")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(updatePoint))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleEditClick(scope.row, 0))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("扣除金币")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(updatePoint))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "text",
                icon: "el-icon-bottom",
                onClick: ($event: any) => (handleDecultPointClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("金币使用流水")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(updatePoint))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "text",
                icon: "el-icon-top",
                onClick: ($event: any) => (handleIncreasePointClick(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("金币增加流水")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: defaultInfo.value,
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      url: url.value,
      validOtherInfo: () => true,
      pageName: "userExpand",
      otherInfo: otherInfo,
      watchDeep: true,
      onSelect: handleSelect
    }, {
      header: _withCtx(({ row }) => [
        (row ?.nickName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(" 用户:"),
              _createElementVNode("span", null, _toDisplayString(row ?.nickName), 1),
              _createTextVNode(" 拥有的金币数量:"),
              _createElementVNode("span", null, _toDisplayString(row ?.point), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "url", "otherInfo"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: tableTitle.value
          }, _unref(pointTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo).value = $event))
          }), null, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "批量添加金币",
      modelValue: batchAddDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((batchAddDialogVisible).value = $event)),
      onClose: handleCloseDialog,
      width: "30%",
      center: "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: handleCancleClick }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirmClick,
          loading: confirmLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "变动金币数" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          placeholder: "请输入金币数",
                          modelValue: points.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((points).value = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ElUpload), {
            ref_key: "uploadRef",
            ref: uploadRef,
            drag: "",
            "auto-upload": false,
            action: "#",
            headers: headers.value,
            "file-list": fileList.value,
            accept: ".xls, .xlsx",
            multiple: false,
            "on-change": handleChange,
            "on-success": handleSuccess,
            "http-request": uploadHttpRequest,
            limit: 1
          }, {
            tip: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["headers", "file-list"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})